namespace $ {

	export function $shm_hitalama_map_widget_entity_table2_display_content(
		map: $shm_hitalama_map,
		table: $shm_hitalama_map_widget_entity_table | null,
		widget: $shm_hitalama_map_widget | null,
		view: $mol_view,
		field: $shm_hitalama_map_widget_entity_table2_field,
		link: string,
		extra: Record< string, unknown > = {},
	): readonly any[] {
		const result = map.$.$mol_error_fence(
			()=> {
				const dataset = field.target_dataset()
				const record = dataset?.record_by_link_direct( new $giper_baza_link( link ).str )
				const display = field.display_field()
				if( !dataset || !record || !display || display.type() !== 'custom' || !display.custom_code().trim() ) {
					return dataset && record ? dataset.record_title( record, display ) : link
				}
				const row = record.object( dataset.fields() )
				return map.execute( display.custom_code(), {
					[ '$' + 'table' ]: table,
					[ '$' + 'row' ]: row,
					[ '$' + 'row_index' ]: dataset.records().indexOf( record ),
					[ '$' + 'column' ]: display.title(),
					[ '$' + 'value' ]: record.value( display ),
					[ '$' + 'widget' ]: widget,
					[ '$' + 'view' ]: view,
					[ '$' + 'record' ]: record,
					[ '$' + 'dataset' ]: dataset,
					[ '$' + 'field' ]: display,
					...extra,
				} )
			},
			error => map.$.$mol_promise_like( error ) ? error : `Недоступная запись: ${ error instanceof Error ? error.message : String( error ) }`,
		)
		if( map.$.$mol_promise_like( result ) ) throw result
		return Array.isArray( result ) ? result : [ result ?? link ]
	}

}
